module.exports = __webpack_public_path__ + "static/img/profile.f674c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile.png
// module id = S4h8
// module chunks = 22